import React from 'react';
import CrossRoad from "../UI/Crossroad";
import { tracksColors } from "../../config/styles";

const Crossroad_13ARed_13BRed = () => <CrossRoad coords="1896.000000, 1215.000000" color={tracksColors.red}/>;

export default Crossroad_13ARed_13BRed;
